const CORE_WORKFLOW = [
    "## Core Workflow",
    "",
    "- For edits to existing slides, call readSlide first.",
    "- Use writeSlide for deterministic search/replace style edits to existing content.",
    "- Keep writes minimal and scoped; avoid broad rewrites when a targeted edit works.",
    "- If the request is ambiguous or risky, ask follow-up questions before editing.",
].join("\n");
const ADD_AND_REORDER = [
    "## Adding and Rearranging Slides",
    "",
    "- Use addSlides for creating/inserting slides.",
    "- addSlides positions are 1-based.",
    "- Use reorderOrDeleteSlides for move/delete operations only.",
    "- Prefer small batches of operations to reduce accidental layout drift.",
].join("\n");
const SEARCH_AND_CONTEXT = [
    "## Search + Context IDs",
    "",
    "- Use currentPresentationSearch for the active deck and presentationLibrarySearchAgent for cross-deck lookups.",
    "- Never invent context IDs; always use tool-returned IDs exactly.",
    "- Typical IDs include slide_*, logo_*, wikimedia_*, artifact_*, and as_*.",
    "- When passing image/logo context to downstream tools, include IDs in global context.",
].join("\n");
const VISUAL_AND_LAYOUT = [
    "## Visual + Layout Consistency",
    "",
    "- Match existing deck typography, spacing, and color treatment unless user requests a restyle.",
    "- Preserve title hierarchy and existing alignment rhythm when inserting new elements.",
    "- Prefer existing layout/component patterns from the deck before introducing novel structures.",
    "- For complex relayout requests, use planning/search context first, then execute with writeSlide/addSlides.",
].join("\n");
const LINKED_EXCEL = [
    "## Linked Excel Edits",
    "",
    "- Use linkedExcelEditorAgent when requests involve linked workbook content.",
    "- Keep spreadsheet instructions precise: ranges, sheet names, and expected output.",
    "- After linked Excel updates, apply slide-side positioning/styling in PowerPoint tools as needed.",
].join("\n");
const BASE_SECTIONS = [
    {
        id: "ppt.workflow.core",
        title: "PowerPoint Core Workflow",
        tags: ["workflow", "readSlide", "writeSlide", "guardrails"],
        content: CORE_WORKFLOW,
    },
    {
        id: "ppt.slides.add_reorder",
        title: "Add/Reorder Slide Operations",
        tags: ["addSlides", "reorderOrDeleteSlides", "positions"],
        content: ADD_AND_REORDER,
    },
    {
        id: "ppt.search.context_ids",
        title: "Search and Context IDs",
        tags: ["search", "context", "ids", "assets"],
        content: SEARCH_AND_CONTEXT,
    },
    {
        id: "ppt.layout.visual_consistency",
        title: "Layout and Visual Consistency",
        tags: ["layout", "style", "consistency", "design"],
        content: VISUAL_AND_LAYOUT,
    },
    {
        id: "ppt.linked_excel.handoff",
        title: "Linked Excel Handoff Guidance",
        tags: ["linkedExcelEditorAgent", "excel", "handoff"],
        content: LINKED_EXCEL,
    },
];
function buildIndexContent(sections) {
    const sectionList = sections
        .map((section) => `- \`${section.id}\` - ${section.title} [${section.tags.join(", ")}]`)
        .join("\n");
    return [
        "## PowerPoint Prompt Environment Index",
        "",
        "Use promptSearch with a natural-language query to find relevant sections.",
        "Then call promptGet with section IDs to retrieve full text.",
        "",
        "Available sections:",
        sectionList,
    ].join("\n");
}
export const PPT_PROMPT_SECTIONS = [
    {
        id: "ppt.promptEnv.index",
        title: "PowerPoint Prompt Environment Index",
        tags: ["index", "navigation"],
        content: buildIndexContent(BASE_SECTIONS),
    },
    ...BASE_SECTIONS,
];
const SECTION_BY_ID = new Map(PPT_PROMPT_SECTIONS.map((section) => [section.id, section]));
export function listPowerPointPromptSections() {
    return PPT_PROMPT_SECTIONS.map(({ id, title, tags }) => ({ id, title, tags }));
}
export function getPowerPointPromptSection(id) {
    return SECTION_BY_ID.get(id);
}
